export default [
    {path: '/use/:html', name: '使用说明', component: () => import('@/view/user/Directions'), meta: {title: '使用说明', }, },
];


// WEBPACK FOOTER //
// src/router/user.js